<template>

<div class="background-img">

  <!--div class="img-wrapper"-->
    <!--div class="img-overlay"></div-->
    <!--b-img src="https://b-synced.io/wp-content/uploads/2017/09/264814382-2560.jpg" fluid alt="Responsive image" /-->
    
      <!--img src="https://b-synced.io/wp-content/uploads/2017/09/264814382-2560.jpg" alt="" /-->
       <!--h1 id="bclassified" style="color: black;">b-classified</h1-->
    <!--b-card
      id="home-card"
      overlay
      img-src="https://b-synced.io/wp-content/uploads/2017/09/264814382-2560.jpg"
      img-alt="Image"
      img-top
      tag="article"
      class="mb-2"
    >
    <br>
    <h1 style="color: white;">b-classified</h1>
    <br><br>
      <b-card-text style="color: white;">
        Welcome to the BC-Classifier Web-UI! This is Web-UI for showcasing our capabilities for automatic classfication. The categorisation scheme is the current Global Product Classification (GPC) standard. The aim of GPC standard is to simplify the global traiding partners to group their products in the same way. This reduces cost and is less time-consuming.
    You can test the different Models for image and text classificataion. Just use the navigation bar on the top to choose what type of data you want to have classified. You can also classify text and image data simultaneously by providing an excel sheet with text data with the corresponding image url to the image data.</b-card-text>
    </b-card-->
  </div>
</template>

<script>
export default {
  name: "ShowPreds",
  props: {
    probabilities: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  font-style: tahoma;
  color: black;
}
h1 {
  color: black;
}
#bclassified{

}
.img-wrapper {
  position: relative;
  width: 100%;
  font-size: 0;
}

.img-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(128,128,128,0.3);
  
}

.img-wrapper img {width: 100%;}

</style>
